import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { Field, reduxForm } from "redux-form";
import { PAYPAL_KEY } from "../../helper/Config";
import { Link } from "react-router-dom";
import { PayPalButton } from "react-paypal-button-v2";
import { updaetPaymentData } from "../../actions/Payment";

class TrainingCheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      complete: false,
      error: false,
      errorMsg: "",
      loading: false,
      tests: 0,
      testname: "",
      amount: 0,
      currency: "EUR",
      promo: ""
    };
  }

  canAccessTrainingPage() {
    const userRole = localStorage.getItem("userRole");
    const navigation = localStorage.getItem("navigation");

    return userRole === "Hr" || (!userRole && navigation === "skills");
  }

  isLoggedInHr() {
    return (
      localStorage.getItem("userRole") === "Hr" &&
      localStorage.getItem("token")
    );
  }

  changeTrainingCount(event) {
    const data = event.target.value.split("~");
    const baseAmount = Number(data[1]);
    const vat = baseAmount * 0.2;
    const finalAmount = baseAmount + vat;

    this.setState({
      tests: data[0],
      amount: finalAmount,
      testname: data[2]
    });
  }

  updateCurrency(e) {
    this.setState({
      currency: e.currentTarget.value
    });
  }

  renderLoading = () => {
    if (this.state.loading) {
      return (
        <div className="p-overlay">
          <div
            className="spinner-border m-5"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }

    return null;
  };

  renderError = () => {
    const { error, errorMsg } = this.state;

    if (error) {
      return <h4 className="text-danger text-center">{errorMsg}</h4>;
    }

    return null;
  };

  renderRadioField = ({ input, label, type, checked, id }) => (
    <div>
      <input {...input} type={type} checked={checked} id={id} />
      <label>{label}</label>
    </div>
  );

  renderSelectBox = () => {
    if (this.props.lang === "en") {
      return (
        <select
          onChange={e => this.changeTrainingCount(e)}
          className="form-control fomt-control-lg"
          defaultValue=""
        >
          <option value="" disabled>
            Please Select
          </option>
          <option value="1~99~DISTANCE LEARNING TRAINING">
            1 consultant (€99 excl. VAT/consultant) = €99 excl. VAT
          </option>
          <option value="2~180~DISTANCE LEARNING TRAINING">
            2 consultants (€90 excl. VAT/consultant) = €180 excl. VAT
          </option>
          <option value="3~255~DISTANCE LEARNING TRAINING">
            3 consultants (€85 excl. VAT/consultant) = €255 excl. VAT
          </option>
          <option value="4~320~DISTANCE LEARNING TRAINING">
            4 consultants (€80 excl. VAT/consultant) = €320 excl. VAT
          </option>
          <option value="5~375~DISTANCE LEARNING TRAINING">
            5 consultants (€75 excl. VAT/consultant) = €375 excl. VAT
          </option>
          <option value="10~650~DISTANCE LEARNING TRAINING">
            10 consultants (€65 excl. VAT/consultant) = €650 excl. VAT
          </option>
        </select>
      );
    }

    return (
      <select
        onChange={e => this.changeTrainingCount(e)}
        className="form-control fomt-control-lg"
        defaultValue=""
      >
        <option value="" disabled>
          Please Select
        </option>
        <option value="1~99~DISTANCE LEARNING TRAINING">
          1 consultant (99€ ht/consultant) = 99 € ht
        </option>
        <option value="2~180~DISTANCE LEARNING TRAINING">
          2 consultants (90€ ht/consultant) = 180 € ht
        </option>
        <option value="3~255~DISTANCE LEARNING TRAINING">
          3 consultants (85€ ht/consultant) = 255 € ht
        </option>
        <option value="4~320~DISTANCE LEARNING TRAINING">
          4 consultants (80€ ht/consultant) = 320 € ht
        </option>
        <option value="5~375~DISTANCE LEARNING TRAINING">
          5 consultants (75€ ht/consultant) = 375 € ht
        </option>
        <option value="10~650~DISTANCE LEARNING TRAINING">
          10 consultants (65€ ht/consultant) = 650 € ht
        </option>
      </select>
    );
  };

  renderTrainingPriceList() {
    if (this.props.lang === "en") {
      return (
        <ul className="indi-ul buy-training-price-list">
          <li>1 consultant (€99 excl. VAT/consultant) = €99 excl. VAT</li>
          <li>2 consultants (€90 excl. VAT/consultant) = €180 excl. VAT</li>
          <li>3 consultants (€85 excl. VAT/consultant) = €255 excl. VAT</li>
          <li>4 consultants (€80 excl. VAT/consultant) = €320 excl. VAT</li>
          <li>5 consultants (€75 excl. VAT/consultant) = €375 excl. VAT</li>
          <li>10 consultants (€65 excl. VAT/consultant) = €650 excl. VAT</li>
        </ul>
      );
    }

    return (
      <ul className="indi-ul buy-training-price-list">
        <li>1 consultant (99€ ht/consultant) = 99 € ht</li>
        <li>2 consultants (90€ ht/consultant) = 180 € ht</li>
        <li>3 consultants (85€ ht/consultant) = 255 € ht</li>
        <li>4 consultants (80€ ht/consultant) = 320 € ht</li>
        <li>5 consultants (75€ ht/consultant) = 375 € ht</li>
        <li>10 consultants (65€ ht/consultant) = 650 € ht</li>
      </ul>
    );
  }

  renderPayPalButton = () => {
    const { tests, amount, currency, testname } = this.state;
    const token = localStorage.getItem("token");
    const userType = localStorage.getItem("role");
    const lang = localStorage.getItem("lang");

    if (!this.isLoggedInHr()) {
      return null;
    }

    if (amount > 0) {
      return (
        <PayPalButton
          amount={amount}
          shippingPreference="NO_SHIPPING"
          options={{
            clientId: PAYPAL_KEY,
            currency: currency
          }}
          onError={err => {
            this.setState({
              error: true,
              errorMsg: err,
              loading: false
            });
          }}
          catchError={err => {
            this.setState({
              error: true,
              errorMsg: err,
              loading: false
            });
          }}
          onSuccess={(details, data) => {
            this.setState({ loading: true });

            try {
              const OrderData = {
                amount: amount,
                tests: tests,
                testname: testname,
                userRole: userType,
                orderId: data.orderID,
                lang: lang
              };

              this.props.updaetPaymentData(token, OrderData, response => {
                if (response.status === 200) {
                  if (response.data.status === "succeeded") {
                    this.setState({
                      complete: true,
                      loading: false
                    });
                  } else {
                    this.setState({
                      error: true,
                      errorMsg: "Error occur during payment",
                      loading: false
                    });
                  }
                } else {
                  this.setState({
                    error: true,
                    errorMsg:
                      response.response.status +
                      " Error!" +
                      response.response.data.message,
                    loading: false
                  });
                }
              });
            } catch (error) {
              this.setState({
                error: true,
                errorMsg: error.message,
                loading: false
              });
            }
          }}
        />
      );
    }

    return null;
  };

  renderTrainingDetail() {
    if (this.props.lang === "en") {
      return (
        <div className="buy-training-detail" style={{ textAlign: "justify", border: "1px solid #ccc", padding: "15px", borderRadius: "5px" }}>
          <FormattedHTMLMessage
            id="buytraining.detail"
            defaultMessage="<p><b>PILOTRH® Certification is individual and permanent.</b> A sliding scale of fees applies depending on the number of consultants training (for groups larger than 10, please contact us).</p><p>Upon completion of this training, you will be able to use the platform with ease and clarity, and answer your clients' questions regarding the content of their reports.</p><p>This online training can be conducted via videoconference if necessary.</p><p>After payment, you will be able to download the online Certification training materials, which you will need to view to obtain the PILOT RH® Certification. This certification, attesting to your use of psychometric tests, will be sent to you by email along with your invoice.</p>"
          />
        </div>
      );
    }

    return (
      <div className="buy-training-detail" style={{ textAlign: "justify", border: "1px solid #ccc", padding: "15px", borderRadius: "5px" }}>
        <FormattedHTMLMessage
          id="buytraining.detail"
          defaultMessage="<p><b>La Certification PILOTRH® est individuelle et définitive.</b> Un tarif dégressif suivant le nombre de consultants à formation (au-delà de 10 nous consulter).</p><p>A l’issue de cette formation vous serez en mesure d’utiliser avec aisance et pédagogie la plateforme et répondre aux questions de vos clients concernant le contenu de leur rapport.</p><p>Cette formation en ligne pourra le cas échéant être réalisée par visioconférence.</p><p>Après votre paiement vous pourrez télécharger la formation Certification en ligne que vous visionnerez pour obtenir la Certification PILOT RH® attestant votre utilisation de tests psychométriques qui vous sera avec votre facture envoyés par email.</p>"
        />
      </div>
    );
  }

  renderGuestNotice() {
    if (!this.isLoggedInHr()) {
      return (
        <div className="alert alert-warning text-center mt-3">
          <FormattedHTMLMessage
            id="buytraining.login.required"
            defaultMessage="Please register or login as Skills Assessment Firm to complete this training purchase."
          />
          <div className="mt-3">
            <Link to="/Register" className="btn btn-warning mx-2">
              <FormattedMessage id="register" defaultMessage="Register" />
            </Link>
            <Link to="/login/Consultant" className="btn btn-primary mx-2">
              <FormattedMessage id="login" defaultMessage="Login" />
            </Link>
          </div>
        </div>
      );
    }

    return null;
  }

  render() {
    const { complete, testname } = this.state;

    if (!this.canAccessTrainingPage()) {
      return (
        <div className="card-div buy-training-card">
          <h4 className="text-danger text-center">
            <FormattedHTMLMessage
              id="buytraining.not.allowed"
              defaultMessage="This training purchase page is available only for Skills Assessment Firm users."
            />
          </h4>
          <div className="col-sm-12 mx-auto text-center mb-4 pb-45">
            <Link to="/" className="btn btn-warning mt-3 mx-3">
              <FormattedMessage id="back.home" defaultMessage="Back to Home" />
            </Link>
          </div>
        </div>
      );
    }

    if (complete) {
      return (
        <div>
          <h4 className="text-success text-center">
            <FormattedMessage
              id="buytraining.success.message"
              defaultMessage="Thank you for your training purchase."
              values={{ nooftest: testname }}
            />
          </h4>
          <div className="col-sm-12 mx-auto text-center mb-4 pb-45">
            <Link to="/hr" className="btn btn-warning mt-3 mx-3">
              <FormattedMessage
                id="buytraining.back.button"
                defaultMessage="BACK TO YOUR TOOLS"
              />
            </Link>
          </div>
        </div>
      );
    }

    return (
      <div className="card-div buy-training-card">
        <React.Fragment>{this.renderLoading()}</React.Fragment>

        <h2 className="text-center mb-4 buy-training-title">
          <FormattedHTMLMessage
            id="buytraining.title"
            defaultMessage={
              this.props.lang === "en"
                ? "PURCHASE OF DISTANCE LEARNING"
                : "ACHAT FORMATION DISTANTIEL"
            }
          />
        </h2>

        {this.renderError()}

        <form>
          <div className="form-group buy-training-currency">
            <div className="form-check form-check-inline">
              <Field
                name="currency"
                component={this.renderRadioField}
                type="radio"
                checked={this.state.currency !== "USD" ? true : false}
                value="EUR"
                label="EUR"
                id="EUR"
                onChange={e => this.updateCurrency(e)}
              />
              <Field
                name="currency"
                component={this.renderRadioField}
                type="radio"
                checked={this.state.currency === "USD" ? true : false}
                value="USD"
                id="USD"
                label="USD"
                onChange={e => this.updateCurrency(e)}
              />
            </div>
          </div>

          <div className="form-group buy-training-select-wrap">
            <label className="font-weight-bold buy-training-label">
              <FormattedMessage
                id="buytraining.noof.consultants"
                defaultMessage={
                  this.props.lang === "en"
                    ? "Number of consultants you wish to train"
                    : "Nombre de consultants que vous souhaitez former"
                }
              />
            </label>

            {this.renderSelectBox()}
          </div>

          {this.renderGuestNotice()}

          <div className="text-center buy-training-secure-wrap">
            {this.renderPayPalButton()}

            <img
              src="assets/images/stripe_secure.png"
              alt="Secure payment"
              className="cc_secure"
            />
          </div>
        </form>

        {this.renderTrainingPriceList()}

        {this.renderTrainingDetail()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isSignedIn: state.auth.isSignedIn,
    lang: state.locale.lang
  };
};

TrainingCheckoutForm = connect(
  mapStateToProps,
  { updaetPaymentData }
)(TrainingCheckoutForm);

export default reduxForm({
  form: "TrainingCheckoutForm"
})(TrainingCheckoutForm);